import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { CheckCircle2 } from "lucide-react";

export default function PaymentSuccess() {
  const [sp] = useSearchParams();
  const [status, setStatus] = useState("checking");
  const sid = sp.get("session_id");

  useEffect(() => {
    if (!sid) return setStatus("error");
    let attempts = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") return setStatus("paid");
        if (attempts++ < 15) setTimeout(poll, 2000);
        else setStatus("timeout");
      } catch { setStatus("error"); }
    };
    poll();
  }, [sid]);

  return (
    <div className="scent-wave min-h-[calc(100vh-4rem)] flex items-center justify-center p-8">
      <div className="max-w-md w-full bg-white rounded-3xl border border-slate-200 p-10 text-center" data-testid="payment-success-card">
        <CheckCircle2 className={`w-16 h-16 mx-auto ${status === "paid" ? "text-emerald-500" : "text-slate-300"}`} />
        <h1 className="mt-4 font-serif text-3xl text-[#0A1128]">
          {status === "paid" ? "Payment Confirmed" : status === "checking" ? "Confirming payment…" : "Still processing"}
        </h1>
        <p className="mt-2 text-slate-500 text-sm">
          {status === "paid"
            ? "Your certification is now under admin review. You'll receive an email once verified."
            : "Please wait a few moments while Stripe finalizes the transaction."}
        </p>
        <Link to="/host">
          <Button className="mt-6 rounded-full bg-[#0A1128] hover:bg-[#1A2A3A] text-white" data-testid="payment-back-host">Back to Dashboard</Button>
        </Link>
      </div>
    </div>
  );
}
